/* eslint-disable max-len */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const sectionTracker = {
	init() {
		this.appendTrackerItems();
		this.trackScrollPosition();
	},
	appendTrackerItems() {
		const sectionTrackerWrapper = document.querySelector('.section-tracker');
		const sectionTrackerElement = sectionTrackerWrapper.querySelector('.section-tracker__list');
		const sections = sectionTrackerWrapper.parentNode.parentNode.querySelectorAll('.wp-block-group');

		if (sections.length === 0 && !sectionTrackerElement) {
			return;
		}
		const trackerItems = [];
		sections.forEach(
			(item) => {
				const sectionID = item.id;
				if (sectionID) {
					const sectionTitle = sectionTracker.getSectionTitle(item);
					const sectionItem = sectionTracker.createNavigationItem(sectionID, sectionTitle);
					trackerItems.push(sectionItem);
				}
			},
		);

		sectionTracker.addItemsToContainerList(trackerItems);
	},
	getSectionTitle(section) {
		let sectionTitle = section.querySelectorAll('h1, h2, h3, h4, h5, h6');
		let headingText = null;
		if (sectionTitle.length === 0) {
			sectionTitle = section.id;
			if (!sectionTitle) {
				return 'Section';
			}
			return sectionTitle;
		}
		sectionTitle.forEach(
			(heading, index) => {
				if (index === 0) {
					headingText = heading.innerText;
				}
			},
		);
		return headingText;
	},
	createNavigationItem(ID, title) {
		const listItem = document.createElement('li');
		const navigationItem = document.createElement('a');

		navigationItem.href = `#${ID}`;
		navigationItem.innerText = title;

		listItem.append(navigationItem);

		return listItem;
	},
	addItemsToContainerList(items) {
		const sectionTrackerElement = document.querySelector('.section-tracker__list');
		if (!sectionTrackerElement) {
			return;
		}
		items.forEach(
			(item) => {
				sectionTrackerElement.append(item);
			},
		);
	},
	trackScrollPosition() {
		const sections = document.querySelectorAll('.wp-block-group[id]');
		const lastItem = [...document.querySelectorAll('.section-tracker__list li')].at(-1);
		let startPosition = 'top 160';

		if (window.innerWidth > 2000 && window.innerWidth < 3000) {
			startPosition = 'top 500';
		} else if (window.innerWidth > 3000) {
			startPosition = 'center 950';
		}

		gsap.registerPlugin(ScrollTrigger);
		document.addEventListener('wheel, touch', () => ScrollTrigger.update());

		const items = [];
		sections.forEach((section) => {
			const item = document.querySelector(`.section-tracker__list a[href="#${section.id}"]`);
			item ? items.push(item) : false;

			ScrollTrigger.create({
				trigger: `#${section.id}`,
				start: startPosition,
				end: `+=${section.getBoundingClientRect().height}`,
				markers: false,
				onToggle: (self) => {
					items.forEach(item => item && item.parentElement.classList.remove('active'))

					if (self.isActive) {
						item && item.parentElement.classList.add('active');
					}
				},
			});
		});

		window.addEventListener('scroll', () => {
			const scrollTop = window.scrollY || document.documentElement.scrollTop;
			const scrollHeight = document.documentElement.scrollHeight;
			const clientHeight = window.innerHeight || document.documentElement.clientHeight;

			const isBottom = scrollTop + clientHeight >= scrollHeight - 5;

			if (isBottom && lastItem) {
				items.forEach((item) => item && item.parentElement.classList.remove('active'));
				lastItem.classList.add('active');
			}
		});
	},
};

export default sectionTracker;
sectionTracker.init();
